import { gql } from "gql";

export const DYNAMIC_PROCESS_NOTIFICATION_TEMPLATE = gql(/* GraphQL */ `
  fragment DynamicProcessNotificationTemplate on NotificationTemplateDto {
    id
    code
    properties
    value {
      title {
        ...LocalizedValueDtoFragment
      }
      body {
        ...LocalizedValueDtoFragment
      }
      prettyBody {
        html {
          ...LocalizedValueDtoFragment
        }
        templateData {
          ...LocalizedValueDtoFragment
        }
      }
    }
  }
`);

export const GET_DYNAMIC_PROCESS_DATA_TO_EDIT = gql(/* GraphQL */ `
  query GetDynamicProcessDataToEdit($processId: ID!) {
    getDynamicProcessById(id: $processId) {
      ... on DynamicEntityBasedModelDefinitionDto {
        id
        name {
          ...LocalizedValueDtoFragment
        }
        icon {
          id
        }
        metaClass
        fields
        route {
          ...EditPathInputData
        }
        allowAttachments
        autoPatchPersonData
        active
        approverNotificationTemplate {
          ...DynamicProcessNotificationTemplate
        }
        initiatorNotificationTemplate {
          ...DynamicProcessNotificationTemplate
        }
      }
    }
  }
`);
